import { IncomingMessage } from 'http'
import { NextRequest } from 'next/server'

export function getIPAddress(
  req: IncomingMessage | undefined
): string | undefined {
  const ip = req?.headers?.['x-forwarded-for']
    ? (req.headers['x-forwarded-for'] as string).replace(' ', '').split(',')[0]
    : req?.connection?.remoteAddress?.replace(' ', '').split(',')[0]

  const request = req as unknown as NextRequest

  if (!ip && request && request.ip) {
    return request.ip.replace(' ', '').split(',')[0]
  } else {
    return ip
  }
}
